var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,0,0,23.78,9.71a.7.7,0,1,0-1.37.27,10.57,10.57,0,1,1-1.24-3.3A.7.7,0,0,0,22.38,6,12,12,0,1,0,12,24Z",
    fill: "#e30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.11,11.37a3.7,3.7,0,0,0,.67-.9,2.51,2.51,0,0,0,.28-1.21,2.89,2.89,0,0,0-.49-1.62,3.37,3.37,0,0,0-1.39-1.18A4.73,4.73,0,0,0,12.1,6a4.54,4.54,0,0,0-2.21.52A3.81,3.81,0,0,0,8.44,7.86a2.93,2.93,0,0,0-.49,1.56,1,1,0,0,0,.31.69,1,1,0,0,0,.77.32q.77,0,1-.92a3.59,3.59,0,0,1,.71-1.33,1.72,1.72,0,0,1,1.31-.45,1.76,1.76,0,0,1,1.24.45,1.43,1.43,0,0,1,.48,1.09,1.24,1.24,0,0,1-.16.62,2.33,2.33,0,0,1-.39.51q-.23.23-.75.69a12.89,12.89,0,0,0-.94.9,2.88,2.88,0,0,0-.77,2.06,1.08,1.08,0,0,0,.29.82,1,1,0,0,0,.71.28.9.9,0,0,0,1-.84q.09-.4.13-.56a1.71,1.71,0,0,1,.13-.32,1.79,1.79,0,0,1,.25-.35,5.62,5.62,0,0,1,.44-.44Q14.72,11.75,15.11,11.37Z",
    fill: "#e30613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.28,19.14a1.42,1.42,0,0,0,0-2.73s-.06,0-.06,0v.7a.08.08,0,0,1-.08.08h-.5a.08.08,0,0,1-.08-.08v-.7s0-.06-.06,0a1.42,1.42,0,0,0,0,2.73s.06,0,.06,0v-.7a.08.08,0,0,1,.08-.08h.5a.08.08,0,0,1,.08.08v.7S12.25,19.16,12.28,19.14Z",
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokFaq);
export default __webpack_public_path__ + "static/media/hok-faq.f7617499cf7de93d075afaded49e9843.svg";
export { ForwardRef as ReactComponent };